$('#menu').on('click', function () {
  $(this).addClass('active');
  $('.menu-list').addClass('menu-list--open');
  $('.mask').css('z-index', 3).fadeIn(400);
  fullpage_api.setAllowScrolling(false);
  $('body').css('overflow', 'hidden');
});

$('.menu-list__close').on('click', function () {
  $('#menu').removeClass('active');
  $('.menu-list').removeClass('menu-list--open');
  $('.mask').css('z-index', 1).fadeOut(400);
  fullpage_api.setAllowScrolling(true);
  $('body').css('overflow', 'visible');
});

$('.menu-list__content--links li').on('click', function () {
  $('.menu-list__content--links li').removeClass('active');
  $(this).addClass('active');
});